export const INCOME = "INCOME";
export const CONTRAGENT = "CONTRAGENT";
export const NOTIFICATIONS = "NOTIFICATIONS";
export const PARTNER_SETTINGS = "PARTNER_SETTINGS";
